import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { withAccount } from '../../components/AccountContext';
import UserList from './UserList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';
import { Loading } from '../../components/Loading';

const LIST_QUERY = gql`
  query($accountId: ID!, $after: String, $before: String, $first: Int, $last: Int) {
    account(id: $accountId) {
      id
      users(after: $after, before: $before, first: $first, last: $last) {
        indexFrom
        indexTo
        totalCount
        pageInfo {
          endCursor
          startCursor
          hasNextPage
          hasPreviousPage
        }
        edges {
          role
          node {
            id
            email
            firstName
            lastName
            enabled
            createdOn
          }
        }
      }
    }
  }
`;

const ACCOUNT_LIST = gql`
  query getViewerAccounts($first: Int, $cursor: String) {
    viewer {
      id
      accounts(first: $first, after: $cursor) {
        edges {
          role
          scopes
          node {
            id
            displayName
            type
            brandingInformation {
              primaryColor
              logo {
                url
                width
                height
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

const UserListContainer = (props) => {
  const { currentAccount, location } = props;
  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort || { sortBy: 'createdOn', sortDir: 'DESC' },
    filter: params.filter,
    first: 100,
  };

  const {
    data: accountData, loading: accountLoading, error: accountError,
  } = useQuery(ACCOUNT_LIST);
  if (accountError) {
    return `Error! ${accountError.message}`;
  }
  if (accountLoading) {
    return <Loading />;
  }

  const { viewer: { accounts } } = accountData;
  return (
    <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only" notifyOnNetworkStatusChange>
      {({ data, loading, error }) => {
        if (error) return `Error! ${error.message}`;

        const connection = data && data.account ? data.account.users : emptyConnection();

        return (
          <UserList
            connection={connection}
            currentAccount={currentAccount}
            loading={loading}
            accounts={accounts}
          />
        );
      }}
    </Query>
  );
};
UserListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(withAccount(UserListContainer)));
